export var onNextFrame = typeof requestAnimationFrame !== 'undefined'
    ? requestAnimationFrame.bind(window)
    : function (fn) { return setTimeout(function () { return fn(Date.now()); }, 1000 / 60); };
